//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//
/**
 * Created by z003f2zh on 03.08.2015.
 */

(function () {

    'use strict';

    angular.module('container.widgets')
        .directive('srsngPopup', srsngPopup);

    function srsngPopup($timeout) {

        return {
            restrict: 'E',
            scope: {
                target: '@',
                anchor: '@',
                align: '@',
                offset: '@',
                stretch: '@',
                arrow: '@',
                visible: '='
            },
            transclude: true,
            templateUrl: 'container/ui/app/widgets/popup/popup.html',
            controller: controller,
            link: link
        };

        function controller($scope) {
            // this is intentional override
        }

        function link(scope, element, attrs) {

            const popupContainer = $('#popup-container');

            var canShow = true;
            var targetPosCheckId; 

            element.addClass('hidden');

            let originalParent = element.parent();

            if (originalParent.length == 0) element.appendTo(popupContainer);

            function adjustPopupToViewport(elementWidth, elementHeight) {
                if (!scope.adjustCount) scope.adjustCount = 0;
                if (scope.adjustCount > 20) {
                    console.log("Error adjusting popup. Stopped after " + scope.adjustCount + " loops.");
                    return;
                }
                scope.adjustCount += 1;

                var rect = element[0].getBoundingClientRect();
                var windowHeight = window.innerHeight || $(window).height();
                var windowWidth = window.innerWidth || $(window).width();

                if (rect.top < 0 || rect.left < 0 ||
                    rect.bottom > windowHeight || rect.left + elementWidth > windowWidth) {

                    if ((rect.left + elementWidth) > windowWidth) element.width(elementWidth);

                    var offsetX = 0;
                    var offsetY = 0;
                    if (scope.offset) {
                        var offsets = scope.offset.split(' ');
                        offsetX = parseInt(offsets[0]) || 0;
                        offsetY = parseInt(offsets[1]) || 0;
                    }

                    if (scope.arrow == 'left' || scope.arrow == 'right' || scope.arrow == 'right-alt') {
                        if (rect.top < 0) {
                            scope.offset = offsetX + " " + (1 - rect.top);
                            attachPopup();
                        }

                        if ((rect.top + elementHeight) > windowHeight) {
                            scope.offset = offsetX + " " + ((0 - ((rect.top + elementHeight + 1) - windowHeight)));
                            attachPopup();
                        }
                    } else {
                        if (rect.left < 0) {
                            scope.offset = (1 - rect.left) + " " + offsetY;
                            attachPopup();
                        }

                        if ((rect.left + elementWidth) > windowWidth) {
                            scope.offset = (0 - ((rect.left + elementWidth + 1) - windowWidth)) + " " + offsetY;
                            element.width(elementWidth);
                            attachPopup();
                        }
                    }

                    if ( 
                        (scope.arrow == 'left' && (rect.left + elementWidth) > windowWidth) ||
                        ((scope.arrow == 'right' || scope.arrow == 'right-alt') && rect.left < 0) ||
                        (scope.arrow == "top" && (rect.top + elementHeight) > windowHeight) ||
                        (scope.arrow == "bottom" && rect.top < 0)
                    ) {

                        element.removeClass('arrow').children('.arrow').removeClass(scope.arrow);
                        element.children('.arrow').css('top', '');
                        element.children('.arrow').css('left', '');

                        var altArrow;
                        var altTmp = attrs.altArrow;
                        if (altTmp == "top" || altTmp == "bottom" ||
                            altTmp == "left" || altTmp == "right") {
                            altArrow = altTmp; 
                        }

                        switch (scope.arrow) {
                            case "left":
                                if (!altArrow) altArrow = "top";
                                if (altArrow == "top") scope.offset = "0 " + -offsetX;
                                else if (altArrow == "bottom") scope.offset = "0 " + offsetX;
                                else if (altArrow == "right") scope.offset = -offsetX + " 0";
                                break;
                            case "right":
                                if (!altArrow) altArrow = "bottom";
                                if (altArrow == "bottom") scope.offset = "0 " + -offsetX;
                                else if (altArrow == "top") scope.offset = "0 " + offsetX;
                                else if (altArrow == "left") scope.offset = -offsetX + " 0";
                                break;
                            case "top":
                                if (!altArrow) altArrow = "right";
                                if (altArrow == "right") scope.offset = -offsetY + " 0";
                                else if (altArrow == "left") scope.offset = offsetY + " 0";
                                else if (altArrow == "bottom") scope.offset = "0 " + -offsetY;
                                break;
                            default:
                                if (!altArrow) altArrow = "left";
                                if (altArrow == "left") scope.offset = -offsetY + " 0";
                                else if (altArrow == "right") scope.offset = offsetY + " 0";
                                else if (altArrow == "top") scope.offset = "0 " + -offsetY;
                                break;
                        }

                        switch (altArrow) {
                            case "left":
                                scope.arrow = "left";
                                scope.anchor = "right center";
                                scope.align = "left center";
                                break;
                            case "right":
                                scope.arrow = "right";
                                scope.anchor = "left center";
                                scope.align = "right center";
                                break;
                            case "top":
                                scope.arrow = "top";
                                scope.anchor = "center bottom";
                                scope.align = "center top";
                                break;
                            default:
                                scope.arrow = "bottom";
                                scope.anchor = "center top";
                                scope.align = "center bottom";
                                break;
                        }

                        element.width(elementWidth);
                        attachPopup();
                    }
                }
            }

            function documentClickCaptured(event) {

                scope.$apply(function () {

                    scope.visible = false;
                    canShow = false;

                    setTimeout(function () {
                        canShow = true;
                    });
                });
            }

            function showPopup() {

                if ('fireClickEarly' in attrs) $('srsng-shell > .shell')[0].addEventListener('mousedown', documentClickCaptured, true); //fire event before other (e.g. blur) events
                else $('srsng-shell > .shell')[0].addEventListener('click', documentClickCaptured, true);

                if (scope.stretch) {
                    element.addClass(scope.stretch.split(' ').map(function (direction) {
                        return 'stretch-' + direction;
                    }).join(' '));
                }

                if ('modal' in attrs) {
                    element.addClass('modal');
                    $('#popup-overlay').removeClass('hidden');
                }

                $timeout(() => {

                    element.removeClass('hidden');

                    if (scope.target) {
                        attachPopup();
                        let scrollpaneElem = element.find('ng-transclude').find('div[srsng-scrollpane]').get(0);
                        if (scrollpaneElem) {
                            $(scrollpaneElem).perfectScrollbar('update');
                        }
                    }
                    else {
                        centerPopup();
                    }
                });
            }

            function attachPopup() {

                let target = $(scope.target);

                if (target.length > 1) {

                    if (originalParent.length > 0) {
                        target = originalParent.closest(`:has(${scope.target})`).find(scope.target).first();
                    } else {
                        console.error(`SRSNG Error: Found multiple possible popup target elements matching '${scope.target}', but popup has no parent.`);
                        return;
                    }
                }

                if (target.length == 0) {

                    console.error(`SRSNG Error: Can't find popup target element matching '${scope.target}'.`);
                    return;
                }

                element.appendTo(popupContainer);

                var elementWidth = element.outerWidth();
                var elementHeight = element.outerHeight();

                var targetOffset = target.offset();
                var targetWidth = target.outerWidth();
                var targetHeight = target.outerHeight();

                var anchors = scope.anchor ? scope.anchor.split(' ') : '';

                var offsets = [0, 0];

                if (scope.offset) {
                    offsets = scope.offset.split(' ');
                    offsets[0] = parseInt(offsets[0]) || 0;
                    offsets[1] = parseInt(offsets[1]) || 0;
                }

                var popupPos = { left: 0, top: 0 };

                element.css(popupPos);

                if (anchors[0] == 'left')
                    popupPos.left = targetOffset.left;
                else if (anchors[0] == 'right')
                    popupPos.left = targetOffset.left + targetWidth;
                else 
                    popupPos.left = targetOffset.left + targetWidth / 2;

                if (anchors[1] == 'top')
                    popupPos.top = targetOffset.top;
                else if (anchors[1] == 'bottom')
                    popupPos.top = targetOffset.top + targetHeight;
                else 
                    popupPos.top = targetOffset.top + targetHeight / 2;

                var aligns = scope.align ? scope.align.split(' ') : '';

                if (aligns[0] == 'left') {
                    popupPos.left += 0;
                } else if (aligns[0] == 'right') {
                    popupPos.left -= elementWidth;
                } else {
                    popupPos.left -= elementWidth / 2;
                }

                if (aligns[1] == 'top') {
                    popupPos.top += 0;
                } else if (aligns[1] == 'bottom') {
                    popupPos.top -= elementHeight;
                } else {
                    popupPos.top -= elementHeight / 2;
                }

                popupPos.left += offsets[0];
                popupPos.top += offsets[1];

                if (scope.arrow) {

                    var borderWidth = parseInt(element.children('.arrow').css('border-width'));

                    if (scope.arrow == 'left') {
                        popupPos.left += borderWidth;
                    } else if (scope.arrow == 'right') {
                        popupPos.left -= borderWidth;
                    } else if (scope.arrow == 'right-alt') {
                        popupPos.left -= borderWidth;
                    } else if (scope.arrow == 'bottom') {
                        popupPos.top -= borderWidth;
                    } else { 
                        popupPos.top += borderWidth;
                    }

                    var arrowPos;

                    if (scope.arrow == 'left' || scope.arrow == 'right' || scope.arrow == 'right-alt') {
                        arrowPos = { top: Math.max(borderWidth, Math.min(elementHeight - borderWidth, targetOffset.top + targetHeight / 2 - popupPos.top)) };
                    } else {
                        arrowPos = { left: Math.max(borderWidth, Math.min(elementWidth - borderWidth, targetOffset.left + targetWidth / 2 - popupPos.left)) };
                    }

                    element.addClass('arrow').children('.arrow').addClass(scope.arrow).css(arrowPos);
                }

                element.css(popupPos);
                adjustPopupToViewport(elementWidth, elementHeight);

                let targetPos = target.offset();

                let hideOnTargetPosChanged = () => {
                    let pos = target.offset();
                    if (targetPos.left != pos.left || targetPos.top != pos.top) {
                        targetPos = pos;
                        scope.visible = false;
                        scope.$apply();
                    } else {
                        targetPosCheckId = requestAnimationFrame(hideOnTargetPosChanged);
                    }
                };

                hideOnTargetPosChanged();
            }

            function centerPopup() {

                element.css({
                    left: 'calc(50% - ' + element.outerWidth() / 2 + 'px)',
                    top: 'calc(50% - ' + element.outerHeight() / 2 + 'px)'
                });

                element.appendTo(popupContainer);
            }

            function removeBindings() {
                if ('fireClickEarly' in attrs) $('srsng-shell > .shell')[0].removeEventListener('mousedown', documentClickCaptured, true);
                else $('srsng-shell > .shell')[0].removeEventListener('click', documentClickCaptured, true);

                $('#popup-overlay').addClass('hidden');
            }

            function hidePopup() {

                scope.adjustCount = 0;

                if (targetPosCheckId) {
                    cancelAnimationFrame(targetPosCheckId);
                    targetPosCheckId = undefined;
                }

                if ('removeOnHide' in attrs) {
                    element.remove();
                } else {
                    removeBindings();
                    element.addClass('hidden');
                    if (originalParent.length > 0) element.appendTo(originalParent);
                }
            }

            var watcher = scope.$watch('visible', function (newValue, oldValue) {
                if (newValue) {

                    if (canShow) {
                        showPopup();
                    } else {
                        scope.visible = false;
                        canShow = true;
                    }
                } else {
                    hidePopup();
                }
            });

            element.on('$destroy', function () {
                removeBindings();
                watcher();
                scope.$evalAsync(function () {
                    scope.$destroy();
                });
            });

            scope.$on('$destroy', function () {
                element.remove();
            });


        }
    }
})();


